import { Theme, makeStyles } from '@material-ui/core';
import { Alert } from '@material-ui/lab';
import React, { FunctionComponent } from 'react';

interface Props {
	message: string;
	onClose(): void;
}

const useStyles = makeStyles((theme: Theme) => ({
	root: {
		position: 'relative',
		width: '100%',
	},
	alert: {
		color: '#fff',
		backgroundColor: '#4b4b4d',
		borderRadius: 0,
	},
}));

export const Notification: FunctionComponent<Props> = (props) => {
	const classes = useStyles();
	const hasMessage = props.message.trim() !== '';

	return hasMessage ? (
		<div className={classes.root}>
			<Alert
				onClose={props.onClose}
				severity="warning"
				className={classes.alert}
			>
				{props.message}
			</Alert>
		</div>
	) : null;
};
